var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"c-options-tab__hotkeys-link",on:{"click":_vm.handleClick}},[_vm._v(" Press "),_c('kbd',[_vm._v("?")]),_vm._v(" to open the hotkey list. ")])}
var staticRenderFns = []

export { render, staticRenderFns }